export const KEEPASS_DATA_WITH_USERS = 'KEEPASS_DATA_WITH_USERS';
export const ERROR_IMPORTING_DATA_WITH_USERS = 'ERROR_IMPORTING_DATA_WITH_USERS';
export const CLEAR_KEEPASS_DATA_WITH_USERS = 'CLEAR_KEEPASS_DATA_WITH_USERS';